import React, { useEffect, useState } from 'react';
import i18next from 'i18next';
import { Container } from 'inversify';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import enTranslations from '@assets/i18n/en.json';
import { InjectionProvider } from '@components/Injection';
import { routes } from '@src/pages';
import { setup } from '@src/setup';
import { AuthProvider } from './contexts/authContext';

i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  compatibilityJSON: 'v4',
  ns: ['translations'],
  defaultNS: 'translations',
  resources: {
    en: {
      translations: enTranslations,
    },
  },
});

const router = createBrowserRouter(routes);

function App() {
  const [container, setContainer] = useState<Container>();

  useEffect(() => {
    setup().then(setContainer);
  }, []);

  if (!container) {
    return null;
  }
  return (
    <I18nextProvider i18n={i18next}>
      <InjectionProvider container={container}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </InjectionProvider>
    </I18nextProvider>
  );
}

export default App;
